// modules
import { handleActions } from 'redux-actions'
// actions and constants
import {
  ACHIEVEMENTS_TABLE_LOADER,
  REDEMPTION_TABLE_LOADER,
  setCompanyGamificationAchievements,
  setCompanyGamificationRedemptionList,
  setCompanyGamificationShopItems,
  setCompanyGamificationTasks,
  setCompanyGamificationVisibility,
  setGamificationTableLoading,
  setRedemptionItemHistory,
  clearRedemptionItemHistory,
  setRedemptionBadgeCount,
  SHOP_TABLE_LOADER,
  TASKS_TABLE_LOADER
} from 'src/store/modules/admin/gamification'

const initialState = {
  achievementsList: [],
  tasksList: [],
  shopItems: [],
  redemptionList: [],
  loading: {
    [ACHIEVEMENTS_TABLE_LOADER]: false,
    [TASKS_TABLE_LOADER]: false,
    [SHOP_TABLE_LOADER]: false,
    [REDEMPTION_TABLE_LOADER]: false
  },
  gamificationEnable: 0,
  redemptionItemHistory: [],
  redemptionBadgeCount: 0
}

export default handleActions(
  {
    [setCompanyGamificationAchievements](state, { payload: achievementsList }) {
      return {
        ...state,
        achievementsList
      }
    },
    [setCompanyGamificationTasks](state, { payload: tasksList }) {
      return {
        ...state,
        tasksList
      }
    },
    [setCompanyGamificationShopItems](state, { payload: shopItems }) {
      return {
        ...state,
        shopItems
      }
    },
    [setCompanyGamificationVisibility](state, { payload: gamificationEnable }) {
      return {
        ...state,
        gamificationEnable: Number(gamificationEnable)
      }
    },
    [setGamificationTableLoading](state, { payload: { loader, flag } }) {
      return {
        ...state,
        loading: {
          ...state.loading,
          [loader]: flag
        }
      }
    },
    [setCompanyGamificationRedemptionList](state, { payload: redemptionList }) {
      return {
        ...state,
        redemptionList
      }
    },
    [setRedemptionItemHistory](state, { payload: redemptionItemHistory }) {
      return {
        ...state,
        redemptionItemHistory
      }
    },
    [clearRedemptionItemHistory](state) {
      return {
        ...state,
        redemptionItemHistory: []
      }
    },
    [setRedemptionBadgeCount](state, { payload: redemptionBadgeCount }) {
      return {
        ...state,
        redemptionBadgeCount
      }
    }
  },
  initialState
)
